import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { AdminUserRoleKey, Permission } from '@chiroup/core/types/AdminUserRole.type';

export type AdminMe = {
  adminUserId: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  roleKey: AdminUserRoleKey;
  mfaEnrolled: boolean;
  permissions: Permission[];
};

const adminMeService = () => {
  const getMe = async (): Promise<AdminMe> => {
    return ChiroUpAPI.get('api', '/admin/me', {});
  };

  return { getMe };
};

export default adminMeService();
